import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { conUnTentativo } from '../utils/primaLettura';
import { useAuthStore } from '../store/useStore';
import { messaggioDa, notificaErrore } from '../utils/notifiche';

/**
 * MioStile — «Torna allo stile di prima» e «Riprova lo stile nuovo», in
 * «Il mio account» (Alex, 30/10/2026: per il gruppo di prova dello stile
 * nuovo «deve esserci possibilita' di disattivare lo stile e tornare al
 * vecchio»).
 *
 * COSA MOSTRARE LO DICE IL SERVER (GET /api/auth/stile, `offerta`): la regola
 * e' services/stileNuovo.js, la stessa di scripts/stileNuovo.js. Qui non si
 * rifa': con `offerta` null il riquadro non c'e' - chi non e' mai stato nel
 * gruppo di prova, chi ne e' stato tolto dall'amministrazione, lo stile per
 * tutti, e «Riprova» quando il rilascio ha un rosso aperto dello stile.
 *
 * DOPO IL CAMBIO LA PAGINA SI RICARICA: i due gusci stanno nello stesso
 * pacchetto ma il menu, le pagine e i fogli si scelgono all'avvio
 * (navigazione/stile.js). Prima si scrive lo stile nuovo nell'utente in
 * memoria, cosi' la pagina ricaricata parte gia' col guscio giusto.
 */
const TESTI = {
    torna: {
        spiega: 'Stai provando lo stile nuovo del gestionale. Se preferisci, puoi tornare a quello di prima: vale solo per te, e da qui potrai riprovarlo.',
        pulsante: 'Torna allo stile di prima',
    },
    riprova: {
        spiega: 'Sei tornato allo stile di prima. Puoi riprovare lo stile nuovo quando vuoi: vale solo per te.',
        pulsante: 'Riprova lo stile nuovo',
    },
};

/* Si sostituisce nelle prove: jsdom non sa ricaricare una pagina. */
export const ricarica = { pagina: () => window.location.reload() };

const MioStile = () => {
    const [offerta, setOfferta] = useState(null);
    const [inCorso, setInCorso] = useState(false);
    const aggiornaUser = useAuthStore((st) => st.aggiornaUser);

    useEffect(() => {
        let vivo = true;
        /* Riprova da sola una volta se la risposta non arriva (il fermo di
           un rilascio di giorno, utils/primaLettura.js); senza risposta il
           riquadro non c'e', come prima. */
        conUnTentativo(() => api.get('/auth/stile'))
            .then((r) => { if (vivo) setOfferta(r?.data?.data?.offerta || null); })
            .catch(() => { if (vivo) setOfferta(null); });
        return () => { vivo = false; };
    }, []);

    const cambia = async () => {
        setInCorso(true);
        try {
            const r = await api.post('/auth/stile', { verso: offerta });
            const v = r?.data?.data?.stile_nuovo;
            if (typeof v === 'boolean' && aggiornaUser) aggiornaUser({ stile_nuovo: v });
            ricarica.pagina();
        } catch (e) {
            notificaErrore(messaggioDa(e, 'Non sono riuscito a cambiare lo stile.'));
            setInCorso(false);
        }
    };

    const testo = TESTI[offerta];
    if (!testo) return null;
    return (
        <section className="prof-riquadro" data-mio-stile={offerta}>
            <h2 className="prof-titolo">Stile del gestionale</h2>
            <p className="prof-spiega">{testo.spiega}</p>
            <div className="prof-azioni">
                <button type="button" className="prof-btn-chiaro" onClick={cambia} disabled={inCorso}>
                    {testo.pulsante}
                </button>
            </div>
        </section>
    );
};

export default MioStile;
